// V14.10.6 — Centralised hint shown next to every file upload input.
// Mirrors the backend rules in `/app/backend/routers/upload_security.py`.
import React from 'react';

export const UPLOAD_HINT_TEXT =
  'Max 25 MB · Allowed: images (png/jpg/webp/gif), video (mp4/mov), audio (mp3/wav), '
  + 'documents (pdf/doc/xls/ppt/csv/txt/kml/kmz) and zip. '
  + 'Executables and scripts are blocked.';

export const UPLOAD_ACCEPT_ATTR =
  '.png,.jpg,.jpeg,.webp,.gif,.bmp,.heic,.heif,'
  + '.mp4,.mov,.webm,.mkv,.avi,'
  + '.mp3,.wav,.ogg,.m4a,.aac,.flac,'
  + '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.csv,.txt,.md,.kml,.kmz,.geojson,'
  + '.zip,.tar,.gz,.7z';

export function UploadHint({ className = '' }) {
  return (
    <p
      className={`text-[10px] text-muted-foreground leading-tight ${className}`}
      data-testid="upload-hint"
    >
      {UPLOAD_HINT_TEXT}
    </p>
  );
}
